
export type GetUserSubscriptionsStatus = typeof GetUserSubscriptionsStatus[keyof typeof GetUserSubscriptionsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserSubscriptionsStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
